module.exports = __webpack_public_path__ + "img/plotbridge-logo.15956aad.svg";